export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于91樱花</h2>
          <p className="text-sm text-foreground-500">了解我们的初心与坚持</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 bg-primary-100 rounded-2xl flex items-center justify-center">
              <i className="ri-flower-line text-2xl md:text-3xl text-primary-500"></i>
            </div>
            <div className="flex-1">
              <p className="text-foreground-700 leading-relaxed mb-4">
                91樱花诞生于动漫爱好者社区，致力于为广大漫迷提供稳定可靠的动漫内容访问入口。我们深知域名波动给用户带来的困扰，因此建立了实时地址监测与更新机制，确保91樱花最新网址始终可用。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                平台收录了涵盖热血、治愈、悬疑、奇幻、恋爱、搞笑等多种类型的动漫作品，从经典老番到当季新番一应俱全。同时提供高清画质与多线路切换功能，让每一位用户都能享受流畅的追番体验。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-6">
                除了内容本身，91樱花还建立了活跃的用户社区，漫迷们可以在这里交流讨论、分享心得。我们始终坚持以用户需求为导向，不断优化站点功能与访问体验，努力成为最值得信赖的动漫入口平台。
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="font-heading text-xl md:text-2xl text-primary-600 mb-1">5年+</div>
                  <div className="text-xs text-foreground-400">稳定运营</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="font-heading text-xl md:text-2xl text-primary-600 mb-1">5000+</div>
                  <div className="text-xs text-foreground-400">动漫收录</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="font-heading text-xl md:text-2xl text-primary-600 mb-1">30万+</div>
                  <div className="text-xs text-foreground-400">活跃用户</div>
                </div>
                <div className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="font-heading text-xl md:text-2xl text-primary-600 mb-1">99.9%</div>
                  <div className="text-xs text-foreground-400">可用率</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}